define(
    'AddToCartModal.View',
    [
        'SCView',
        'Utils',
        'addtocartmodal.tpl'
    ],
    function (
        SCViewModule,
        Utils,
        template
    ) {
        'use strict';

        var SCView = SCViewModule.SCView;

        function AddToCartModalView(options) {
            SCView.call(this, options);
            this.template = template;
            this.title = Utils.translate('Added to Cart');
            this.item = options.item;
        }

        AddToCartModalView.prototype = Object.create(SCView.prototype);
        AddToCartModalView.prototype.constructor = AddToCartModalView;

        AddToCartModalView.prototype.getContext = function () {
            return {
                link: this.item.link,
                image: this.item.image,
                name: this.item.name,
                sku: this.item.sku,
                price: this.item.price,
            };
        }

        return AddToCartModalView;
    });
